import { useEffect, useState, useCallback, useMemo } from "react";
import { Col, Form, Select } from "antd";
import debounce from "lodash.debounce";
import { GET_SEWING_LINES } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "../../../common/CustomDatePicker";
import moment from "moment";

const HourlyOperationTrackingFilterFields = ({ initialTableData }) => {
  const [lineList, setLineList] = useState([]);
  const { Option } = Select;

  // Fetch data with error handling
  const fetchData = async (endpoint, params = {}) => {
    try {
      const response = await getData(endpoint, false, params);
      if (response?.data?.code === 200) {
        return response?.data?.data || [];
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return [];
  };

  // Fetch line list
  const getLineList = useCallback(
    debounce(async (filterValues = {}) => {
      const data = await fetchData(GET_SEWING_LINES, {
        per_page: 100,
        ...filterValues,
      });
      setLineList(data);
    }, 300),
    [],
  );

  // Initial data fetch
  useEffect(() => {
    getLineList();
  }, [getLineList]);

  // Memoized options for better performance
  const lineOptions = useMemo(
    () =>
      isArrayAndHasValue(lineList) &&
      lineList.map((line) => (
        <Option key={line.id} value={line.id}>
          {line.name}
        </Option>
      )),
    [lineList],
  );

  return (
    <>
      <Col span={4}>
        <Form.Item 
          label="Date" 
          name="query_date"
          initialValue={moment()}
          rules={[
            {
              required: true,
              message: "Please select Date!",
            },
          ]}
        >
          <CustomDatePicker
            style={{ width: "100%" }}
            size="small"
            placeholder="Select Date"
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item 
          label="Line" 
          name="line_id"
          rules={[
            {
              required: true,
              message: "Please select Line!",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select a Line"
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => getLineList()}
            onSearch={(value) => getLineList({ name: value })}
            filterOption={false}
          >
            {lineOptions}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default HourlyOperationTrackingFilterFields;

